import styled from 'styled-components';

export const Place = styled.div`
  margin: 0 0 10px;

  label {
    margin: 0 10px 0 0;
  }
`;
